define('views/modules/member/member/modal/add-test-client-modal',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/i18n',
    // views
    'views/parts/modal/modal',
    'views/parts/form/choices',
    // templates
    'text!templates/modules/member/member/modal/add-test-client-modal.html',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    i18n,
    // views
    VModal,
    VChoices,
    // templates
    TAddTestClientModal
) {

    var VAddTestClientModal = VModal.extend({
        template: TAddTestClientModal,
        regions: {
            checkbox: ".remember-checkbox"
        },
        modal: function() {
            return {
                title: i18n.t('add-test-client-title'),
                size: 'medium',
                buttons: {
                    cancel: {
                        label: i18n.t('add-test-client-no'),
                        callback: _.noop
                    },
                    confirm: {
                        label: i18n.t('add-test-client-yes'),
                        callback: this.callback
                    }
                }
            };
        },

        initialize: function(options) {
            this.callback = options.callback;

            this.model = new Backbone.Model({ remember: false });

            this.view = {
                checkbox: new VChoices({
                    model: this.model,
                    attribute: 'remember',
                    label: 'add-test-client-dont-ask-me-again'
                })
            }
        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext({})));

            this.generateZones();
            this.assign(this.view.checkbox, this.zone.$checkbox);

            return this.renderModal();
        },

        onHide: function() {
            if (this.model.get('remember')) {
                document.cookie = "show_add_test_client_modal=false";
            }
        }
    });

    return VAddTestClientModal;
});

